import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MinistryMonitorService } from 'src/app/core/services/ministry-monitor.service';
import { ChannelDisplay, MinistryMonitor, MinistryStateRecord } from 'src/app/core/interfaces/ministry-monitor';

@Component({
  selector: 'app-rndc-status',
  templateUrl: './rndc-status.component.html',
  styleUrls: ['./rndc-status.component.scss']
})
export class RndcStatusComponent implements OnInit, OnDestroy {

  channels: ChannelDisplay[] = [
    {
      label: 'Canal A — WS 1', stateField: 'stateChannel1', lastCheckedField: 'lastCheckedChannel1', isUp: false, lastChecked: null,
      processes: ['Cumplir remesa', 'Cumplir manifiesto', 'Cancelar remesa', 'Cancelar manifiesto',
                  'Conductor / Vehículo', 'Registro urbano', 'Remesa urbana', 'RMM / RNMM', 'Factura electrónica'],
    },
    {
      label: 'Canal B — WS 2', stateField: 'stateChannel2', lastCheckedField: 'lastCheckedChannel2', isUp: false, lastChecked: null,
      processes: ['Crear remesa', 'Crear manifiesto', 'Consulta remesa', 'Consulta manifiesto'],
    },
    {
      label: 'Canal C — PLC', stateField: 'stateChannelPLC', lastCheckedField: 'lastCheckedChannelPLC', isUp: false, lastChecked: null,
      processes: ['Costo SICETAC', 'Procesos especiales'],
    },
  ];

  history: MinistryStateRecord[] = [];
  loadingHistory = false;

  private statusSub: Subscription;
  private firstLoad = true;

  constructor(private ministryMonitorService: MinistryMonitorService) {}

  ngOnInit() {
    this.ministryMonitorService.startListener();
    this.loadHistory();
    this.statusSub = this.ministryMonitorService.currentStatus$.subscribe((status: MinistryMonitor) => {
      if (!status) return;
      this.channels = this.channels.map(ch => {
        const ts = status[ch.lastCheckedField] as any;
        return {
          ...ch,
          isUp: !!status[ch.stateField],
          lastChecked: ts && ts.toDate ? ts.toDate() : null,
        };
      });
      if (!this.firstLoad) {
        this.loadHistory();
      }
      this.firstLoad = false;
    });
  }

  loadHistory() {
    if (this.loadingHistory) return;
    this.loadingHistory = true;
    this.ministryMonitorService.getHistory(50).then((records) => {
      this.history = records || [];
    }).catch(() => {}).finally(() => {
      this.loadingHistory = false;
    });
  }

  ngOnDestroy() {
    if (this.statusSub) this.statusSub.unsubscribe();
    this.ministryMonitorService.stopListener();
  }
}
